import React from 'react';
import { User } from 'lucide-react';
import { searchPageStyles } from './SearchPage.styles';
import UserProfile from '../UserProfile';

const HeaderButtons = ({
  loading,
  user,
  headerScrolled,
  profileOpen,
  setProfileOpen,
  profileRef,
  navigate,
}) => {
  return (
    <>
    <div
      style={{
        ...searchPageStyles.headerButtons,
        top: headerScrolled
          ? 'calc(12px + env(safe-area-inset-top, 0px))'
          : 'calc(16px + env(safe-area-inset-top, 0px))',
        right: headerScrolled
          ? 'calc(12px + env(safe-area-inset-right, 0px))'
          : 'calc(20px + env(safe-area-inset-right, 0px))',
      }}
      className="header-buttons"
    >
      {loading ? (
        <div style={{
          width: headerScrolled ? 32 : 40,
          height: headerScrolled ? 32 : 40,
          borderRadius: '50%',
          background: 'var(--color-bg)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '2px solid var(--color-border)',
          transition: 'all 0.2s cubic-bezier(.4,0,.2,1)',
        }}>
          <div style={{
            ...searchPageStyles.loadingSpinner,
            width: headerScrolled ? 12 : 16,
            height: headerScrolled ? 12 : 16,
          }}></div>
        </div>
      ) : user ? (
        <div ref={profileRef} style={{ position: 'relative' }}>
          <div
            style={{
              ...searchPageStyles.profileButton,
              width: headerScrolled ? 32 : 40,
              height: headerScrolled ? 32 : 40,
              fontSize: headerScrolled ? 14 : 16,
            }}
            onClick={() => setProfileOpen((open) => !open)}
            title={user.displayName || user.email}
          >
            {user.displayName ? user.displayName.charAt(0).toUpperCase() : user.email.charAt(0).toUpperCase()}
          </div>
          {profileOpen && <UserProfile />}
        </div>
      ) : (
        <button 
          onClick={() => navigate('/auth')}
          className="btn btn-primary"
          data-testid="login-button"
          style={{
            ...searchPageStyles.loginButton,
            fontSize: headerScrolled ? '13px' : '15px',
            padding: headerScrolled ? '8px 12px' : '10px 22px',
            gap: headerScrolled ? '4px' : '8px',
            minWidth: headerScrolled ? 'auto' : '100px',
            height: headerScrolled ? '32px' : '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span style={{ display: 'inline-block !important' }}>
            <User size={headerScrolled ? 14 : 18} />
          </span>
          <span className="login-text" style={{ display: 'inline', marginLeft: 6 }}>
            Login
          </span>
        </button>
      )}
    </div>
    <style>
      {`
        @media (max-width: 480px) {
          .header-buttons .login-text {
            display: none !important;
          }
        }
      `}
    </style>
    </>
  );
};

export default HeaderButtons;
